module.exports = __webpack_public_path__ + "assets/ev.e06861cd.svg";